import WrappedText from '../wrappedText';
import { createStyles, makeStyles } from '@mui/styles';
import { Colors } from 'copyright-clearance-center-common-ui';

const useStyles = makeStyles(() =>
	createStyles({
		title: {
			fontWeight: '500',
			fontSize: '1.25rem',
			lineHeight: '1.75rem',
			color: Colors.neutral900
		}
	})
);

export interface IDocumentTitleProps {
	title: string;
}

const DocumentTitle: React.FunctionComponent<IDocumentTitleProps> = ({ title }) => {
	const classes = useStyles();

	return <WrappedText text={title} className={classes.title} />;
};

export default DocumentTitle;
